import { noop } from 'lodash-es';
import React from 'react';
import { PinTR, Position, ToolbarButton, UnreadBubble } from '@marvelapp/ui';
import LeaveComment from '../containers/LeaveComment';
import { CommentIcon } from './icons';
export default function Comments(_a) {
    var areCommentsVisible = _a.areCommentsVisible, _b = _a.commentCount, commentCount = _b === void 0 ? 0 : _b, notification = _a.notification, _c = _a.onCommentButtonClick, onCommentButtonClick = _c === void 0 ? noop : _c, _d = _a.onNotificationClick, onNotificationClick = _d === void 0 ? noop : _d;
    var comments = commentCount === 1 ? 'comment' : 'comments';
    var count = commentCount === 0 ? 'No' : commentCount;
    return (React.createElement(Position, null,
        React.createElement(LeaveComment, null),
        React.createElement(ToolbarButton, { alignItems: "center", display: "flex", fill: "slate", isActive: areCommentsVisible, onClick: notification ? onNotificationClick : onCommentButtonClick },
            React.createElement(CommentIcon, { display: "block", marginRight: 10 }),
            React.createElement("div", { className: "comments-count" },
                count,
                " ",
                comments),
            notification && (React.createElement(PinTR, { right: -4, top: -4 },
                React.createElement(UnreadBubble, null))))));
}
